import { render, staticRenderFns } from "./flip-cards.vue?vue&type=template&id=742f7716&scoped=true&"
import script from "./flip-cards.vue?vue&type=script&lang=js&"
export * from "./flip-cards.vue?vue&type=script&lang=js&"
import style0 from "./flip-cards.vue?vue&type=style&index=0&id=742f7716&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742f7716",
  null
  
)

export default component.exports